module.exports = __webpack_public_path__ + "img/D2TZ-logo.777370af.png";